<template>
	<div class="p-0 m-0">
		<p class="">Select Your Preferred Payment Method:</p>
		<div class="">
			<b-field>
				<b-radio
					v-model="paymentMethod"
					size="is-normal"
					native-value="Bank Card">
					Credit/Debit Card
				</b-radio>
			</b-field>
			<b-field>
				<b-radio
					v-model="paymentMethod"
					size="is-normal"
					native-value="Lynk">
					Lynk
				</b-radio>
			</b-field>
		</div>
		<hr style="border-top: 1px solid #ddd" />
		<div v-show="paymentMethod == 'Lynk'">
			<div class="buttons has-addons">
				<button
					@click="lynkTransactionType = LYNK_TRANSACTION_TYPE.USERNAME"
					style="width: 50%"
					class="button"
					:class="{
						'is-selected is-success':
							lynkTransactionType == LYNK_TRANSACTION_TYPE.USERNAME,
					}">
					<i class="fa-solid fa-at"></i>&nbsp;&nbsp;Username
				</button>
				<button
					@click="lynkTransactionType = LYNK_TRANSACTION_TYPE.QR_CODE"
					style="width: 50%"
					class="button"
					:class="{
						'is-selected is-success':
							lynkTransactionType == LYNK_TRANSACTION_TYPE.QR_CODE,
					}">
					<i class="fa-solid fa-qrcode"></i>&nbsp;&nbsp;QR Code
				</button>
			</div>
			<div v-show="lynkTransactionType == LYNK_TRANSACTION_TYPE.QR_CODE">
				<p>
					Make your payment with Lynk using the QR Code below or send
					directly to the Lynk ID
					<span class="has-text-success has-text-weight-bold">@jamart</span
					>, then enter your transaction id in the box below. Click here to
					watch an instructional video on how to pay with Lynk through our
					platform.
				</p>
				<p class="has-text-centered is-size-4 has-text-success mb-0">
					Jamart Marketplace Limited
				</p>
				<p
					class="has-text-centered is-size-4 has-text-success"
					style="line-height: 1rem">
					@jamart
				</p>

				<img
					class="mb-2"
					style="max-width: 80%; margin-left: 10%; margin-right: 10%"
					src="/image/payment/lynk_qr_code.svg" />
				<!--
            <span class="is-block has-text-centered is-size-5 has-text-gray" >
               Click the image to expand it.
            </span>
         -->
				<p class="has-text-centered is-size-4 has-text-success">
					Total: <span class=""> {{ totalString }}</span>
				</p>
				<input
					ref="lynkTransactionCode"
					v-model="lynkTransactionCode"
					@input="onInputEvent"
					class="input"
					type="input"
					placeholder="Lynk Transaction Code e.g. 198765432" />
			</div>
			<div v-show="lynkTransactionType == LYNK_TRANSACTION_TYPE.USERNAME">
				Enter your Lynk Username

				<div class="field has-addons">
					<p class="control">
						<a class="button is-static"><i class="fa-solid fa-at"></i></a>
					</p>
					<div class="control is-expanded">
						<div class="is-fullwidth">
							<input
								ref="lynkUsername"
								v-model="lynkUsername"
								@input="onLynkUsernameInput"
								class="input"
								type="text"
								max-length="40"
								placeholder="your-lynk-username" />
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-show="paymentMethod == 'Bank Card'">
			<div class="field pt-2">
				<div class="columns is-mobile pl-2 pr-2 pt-3">
					<div class="column has-text-left m-0 p-0">
						<label
							class="label"
							for="confirm-email"
							>Card Number</label
						>
					</div>
					<div class="column has-text-right m-0 p-0 is-narrow">
						<i class="fab fa-lg fa-cc-visa"></i>&nbsp;&nbsp;<i
							class="fab fa-lg fa-cc-mastercard"></i>
					</div>
				</div>
				<div class="control">
					<!--Credit Card Length is between 10 and 19 and usually 16 -->
					<input
						v-model="displayedCardNumber"
						@input="onCardNumberInput"
						class="input"
						type="text"
						maxlength="23"
						pattern="([0-9,-])*"
						placeholder="e.g. 4832-5432-3426-9243" />
				</div>
			</div>
			<div class="field mt-5 is-horizontal">
				<div class="field-body">
					<div class="field">
						<label
							class="label"
							for=""
							>Expiration Date <i style="">(mm/yy)</i></label
						>
						<input
							v-model="payment.expiration"
							@input="
								(event) => {
									formatExpiryDate(event);
									return onInputEvent();
								}
							"
							class="input"
							type="text"
							maxlength="5"
							:pattern="'^(0?[1-9]?|1[0-2])(\/?)([2-9]{1}[0-9]?){0,1}$'"
							placeholder="e.g. 02/26" />
						<!-- '^(0?[1-9]?|1[0-2])(\/?)([2-9]{1}[0-9]?){0,1}$' -->
						<!-- Not using the below regex because the users browser may not have the correct date -->
						<!-- '^(0?[1-9]?|1[0-2])(\/?)([' +
							new Date().getFullYear().toString().substr(2)[0] +
							'-9]{1}[' +
							new Date().getFullYear().toString().substr(2)[1] +
							'-9]?){0,1}$' -->
					</div>
					<div
						class="field w-100-mobile"
						style="width: 40%">
						<label
							class="label"
							for=""
							>CVC</label
						>
						<input
							v-model="payment.cvc"
							@input="onInputEvent"
							class="input"
							type="text"
							maxlength="4"
							pattern="[0-9]*"
							placeholder="e.g. 123" />
					</div>
				</div>
			</div>
			<div class="field mt-3">
				<div class="columns pl-2 pr-2 pt-3">
					<div class="column has-text-left m-0 p-0">
						<label
							class="label ml-1"
							for="confirm-email"
							>Cardholder Name</label
						>
					</div>
				</div>
				<div class="control">
					<input
						v-model="payment.name"
						@input="onInputEvent"
						class="input"
						type="text"
						maxlength="61"
						pattern="^([-A-z]{0,30}[ ]?[-A-z]{0,30})$"
						placeholder="e.g. Johnathan Doberman" />
				</div>
			</div>
			<div>
				<div class="pt-2">
					<!-- Using v-on:change.native since it works -->
					<b-checkbox
						v-model="showBillingAddress"
						v-on:change.native="onInputEvent"
						>Enter Billing Address (Recommended)</b-checkbox
					>
					<div class="field">
						<p class="help has-text-grey is-size-7">
							Your billing address is not absolutely required but it
							helps our payment processor verify your information and
							makes your transaction more seamless.
						</p>
					</div>
					<BillingAddressInput
						ref="billingAddressInput"
						@input="onInputEvent"
						v-show="showBillingAddress" />
				</div>
			</div>
			<div class="columns is-mobile">
				<div
					class="column is-6"
					style="margin-right: auto">
					<figure
						class="image ml-0 mr-0 mt-2 pt-1 mb-0"
						style="aspect-ratio: 772 / 346; max-height: 6rem">
						<img src="/image/asset/powertranz.svg" />
					</figure>
				</div>
				<div class="column is-6">
					<div class="columns is-multiline is-mobile">
						<div
							class="column is-narrow pr-1 pb-0"
							style="margin-left: auto">
							<figure
								class="image ml-0 mr-1 mt-0 mb-0"
								style="max-height: 2.7rem; aspect-ratio: 1 / 1">
								<img
									src="/image/asset/payment-visa-secure.png"
									style="border: 1px solid rgb(235, 235, 235)" />
							</figure>
						</div>
						<div class="column is-narrow pl-1 pb-0">
							<figure
								class="image m-0 p-0"
								style="max-height: 2.7rem; aspect-ratio: 327 / 245">
								<img
									src="/image/asset/payment-mastercard-id-check.png"
									style="border: 1px solid rgb(235, 235, 235)" />
							</figure>
						</div>
						<div class="column is-full pt-0">
							<p
								class="is-size-7 pt-0 pb-0 m-0 has-text-right pr-0 has-text-grey">
								3D-Secure
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<style type="text/css" scoped>
	/* Mobile: up to 768px */
	@media screen and (max-width: 768px) {
		.w-50-mobile {
			width: 50% !important;
		}
		.w-100-mobile {
			width: 100% !important;
		}
	}
	.label {
		font-weight: normal;
		font-size: 0.9rem;
	}
	input:valid {
	}
	input:invalid {
		background-color: rgb(255, 190, 190);
	}
	figure img,
	img {
		max-height: initial; /*max-height set to initial to counteract navbar-item img max-height*/
	}
</style>
<script type="text/javascript">
	import BillingAddressInput from "./BillingAddressInput.vue";
	export default {
		components: { BillingAddressInput },
		emits: ["input"],
		props: {
			total: Map,
		},
		data() {
			return {
				LYNK_TRANSACTION_TYPE: {
					USERNAME: "username",
					QR_CODE: "qr_code",
				},
				isPaymentInformationValid: false,
				paymentMethod: "Bank Card",
				payment: {
					card_number: "",
					expiration: "",
					cvc: "",
					name: "",
				},
				displayedCardNumber: "",
				lynkTransactionCode: "",
				lynkUsername: "",
				showBillingAddress: false,
				lynkTransactionType: "username",
			};
		},
		computed: {
			cardNumberOnlyDigits() {
				return this.payment.card_number.replace(/\D/g, "");
			},
			lynkUsernameWithAtSymbol() {
				if (this.lynkUsername.startsWith("@")) {
					return this.lynkUsername;
				} else {
					return "@" + this.lynkUsername;
				}
			},
			isCardNumberValid() {
				return (
					this.cardNumberOnlyDigits.length >= 15 &&
					this.cardNumberOnlyDigits.length <= 19
				);
			},
			details() {
				let payment = null;
				switch (this.paymentMethod) {
					case "Bank Card":
						payment = this.payment;

						payment.card_number = payment.card_number.replace(/\D/g, "");
						payment.expiration = payment.expiration.replace(/\D/g, "");
						payment.cvc = payment.cvc.replace(/\D/g, "");
						if (this.showBillingAddress == true) {
							payment.billingAddress =
								this.$refs.billingAddressInput.details();
						} else {
							// for some reason if billing address is entered once in the parent object it will be there
							// this line will be used to delete billingAddress if showBillingAddress is false
							if (typeof payment.billingAddress != "undefined") {
								delete payment.billingAddress;
							}
						}
						break;
					case "Lynk":
						payment = {};
						if (
							this.lynkTransactionType ==
							this.LYNK_TRANSACTION_TYPE.USERNAME
						) {
							payment.lynkUsername = this.lynkUsernameWithAtSymbol;
						} else if (
							this.lynkTransactionType ==
							this.LYNK_TRANSACTION_TYPE.QR_CODE
						) {
							payment.transactionCode =
								this.$refs.lynkTransactionCode.value;
						}
						break;
				}
				return payment;
			},
			method() {
				return this.paymentMethod;
			},
			totalString() {
				let s = "";
				let counter = 0;
				this.total.forEach((value, key, map) => {
					counter++;
					if (counter < map.size) {
						s += `${new Intl.NumberFormat("en-US", {
							style: "currency",
							currency: "USD",
						}).format(value)} ${key} + `;
					} else {
						s += `${new Intl.NumberFormat("en-US", {
							style: "currency",
							currency: "USD",
						}).format(value)} ${key}`;
					}
				});
				return s;
			},
		},
		methods: {
			onLynkUsernameInput(event) {
				const prohibitedCharacters = "@#$%^&*()+=[]{}|;:\"'\\,<>/?`~";
				const originalValue = event.target.value;
				const sanitizedValue = originalValue
					.split("")
					.filter((value) => !prohibitedCharacters.includes(value))
					.join("");

				this.lynkUsername = sanitizedValue;

				this.onInputEvent();
			},
			onInputEvent() {
				this.$emit("input", this.validatePaymentInformation());
			},
			paymentMethodChanged() {
				this.$emit("input", this.validatePaymentInformation());
			},
			clear() {
				Object.keys(this.payment).forEach(
					(paymentAttribute, index, array) => {
						this.payment[paymentAttribute] = "";
					}
				);
				this.displayedCardNumber = "";
				this.$refs.showBillingAddress = false;
			},
			formatCreditCard(value) {
				const digits = value.replace(/\D/g, "").substring(0, 19);
				return digits.match(/.{1,4}/g)?.join("-") || "";
			},
			onCardNumberInput(event) {
				// the card number is usually 16 but for some cards it can be 19. so accomodate for that
				// but presume that 16 digits will be entered and don't automatically add the dash after 16 characters
				const digits = event.target.value
					.replace(/\D/g, "")
					.substring(0, 19);
				this.payment.card_number = digits;
				this.displayedCardNumber = this.formatCreditCard(digits);
				this.onInputEvent();
			},
			formatExpiryDate(event) {
				// Set payment.expiration to mm/yy and format it
				let x = this.payment.expiration;
				let index = x.lastIndexOf("/");
				let test = x.substr(index + 1);
				if (
					event.inputType === "deleteContentBackward" &&
					test.length === 0
				) {
					this.payment.expiration = x.substr(0, x.length - 1);
				} else if (
					event.inputType === "deleteContentBackward" &&
					test.length == 2 &&
					test.length
				) {
					setTimeout(() => {
						this.payment.expiration = x.substr(0, x.length - 1);
					}, 1);
				} else if (event.inputType === "insertText" && test.length > 2) {
					// automatically add the slash if more than two characters are entered
					setTimeout(() => {
						this.payment.expiration =
							x.substr(0, x.length - 1) + "/" + x.substr(x.length - 1);
					}, 1);
				} else if (
					event.inputType === "insertText" &&
					test.length == 2 &&
					this.payment.expiration.length < 4
				) {
					// automatically add the slash if only two characters are entered
					setTimeout(() => {
						this.payment.expiration = x + "/";
					}, 1);
				} else if (index == -1 && this.payment.expiration.length > 2) {
					//automatically add the slash if only three characters are entered
					setTimeout(() => {
						this.payment.expiration =
							x.substr(0, 2) + "/" + x.substr(2, x.length);
					}, 1);
				}

				if (
					index == 1 &&
					this.payment.expiration.length > 2 &&
					parseInt(this.payment.expiration.substr(0, 2)) < 10
				) {
					setTimeout(() => {
						this.payment.expiration = "0" + this.payment.expiration;
					}, 2);
				}
			},
			validatePaymentInformation() {
				this.isPaymentInformationValid =
					this.isSelectedPaymentMethodValid();

				return this.isPaymentInformationValid;
			},
			isSelectedPaymentMethodValid() {
				if (this.paymentMethod == "Bank Card") {
					const cardDataIsValid =
						this.isCardNumberValid &&
						this.payment.expiration.length &&
						this.payment.cvc.length >= 3 &&
						this.payment.name.length > 0;

					let billingAddressValid = true;
					if (this.showBillingAddress) {
						billingAddressValid =
							this.$refs.billingAddressInput.isBillingAddressValid();
					}

					return cardDataIsValid && billingAddressValid;
				} else if (this.paymentMethod == "Lynk") {
					if (
						this.lynkTransactionType ==
						this.LYNK_TRANSACTION_TYPE.USERNAME
					) {
						return Boolean(this.$refs.lynkUsername.value.length);
					} else if (
						this.lynkTransactionType == this.LYNK_TRANSACTION_TYPE.QR_CODE
					) {
						return Boolean(this.$refs.lynkTransactionCode.value.length);
					}
				}
			},
		},
		watch: {
			paymentMethod() {
				this.paymentMethodChanged();
			},
		},
	};
</script>
